export default "__VITE_ASSET__DVrU48Cf__"